import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface BrandsSelectorProps {
  options: string[];
  selectedBrand: string;
  onSelectedBrandChange: (brand: string) => void;
}

// Mobile's replacement for the desktop BrandsFilterItems.tsx - that's an
// Autocomplete, which renders a real editable text input. On a touch
// device, tapping ANY editable input opens the on-screen keyboard, even
// though there's nothing to type here - it's just picking from a short
// fixed list, not searching. A plain MUI Select never renders an editable
// field at all - tapping it opens a menu, no keyboard involved - which is
// also what the mockup itself uses for this control (a native <select>,
// not a searchable combobox).
export default function BrandsSelector({ options, selectedBrand, onSelectedBrandChange }: BrandsSelectorProps) {
  const handleChange = (event: SelectChangeEvent) => {
    onSelectedBrandChange(event.target.value);
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel color="secondary">Brand</InputLabel>
      <Select label="Brand" value={selectedBrand} onChange={handleChange} color="secondary">
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
